import './styles/bolRatingBar.scss';
import React from 'react';
import classNames from 'classnames';

interface Props {
    value: string | number;
    className?: string;
}

export default function BolRatingBar(props: Props) {
    const {value, className} = props;

    const fillStyle = {
        width: `${value}%`
    };

    return (
        <div className={classNames('bol-rating-bar', className)}>
            <div className='rating-bar-wrapper'>
                <div className='bar bar-inactive'></div>
                <div className='bar bar-active' style={fillStyle}></div>
            </div>
        </div>
    );
}
